import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { ShipperForm } from '@/services/shipper/schemas'
import BaseShipperForm from './BaseShipperForm'

interface Props {
  type: 'create' | 'update'
  form: UseFormReturn<ShipperForm>
  onLogisticsServiceTypeChange?: (value: string) => void
}

function MCDShipperForm({ type, form, onLogisticsServiceTypeChange }: Props) {
  return (
    <div>
      <BaseShipperForm type={type} form={form} onLogisticsServiceTypeChange={onLogisticsServiceTypeChange} />
    </div>
  )
}

export default MCDShipperForm
